import { useNavigate } from "react-router-dom";
import { useCallback, useContext, useState } from "react";
import { PATH_INFO } from "../util/helper";
import bgImg from "../../assets/images/home-bg.svg";
import AiMeasureLogo from "../../assets/images/logos/ai-measure-logo-black.svg";
import toyoshimaLogo from "../../assets/images/logos/toyoshima-black.svg";
import { Button, Input } from "antd";
import { UpdateAuthContext } from "../../context/authContext";

export function Login() {
  const { login } = useContext(UpdateAuthContext)
  const navigate = useNavigate();

  const [userInfo, setUserInfo] = useState({ email: '', password: '' })
  const [status, setStatus] = useState<'error' | ''>('')

  const onClickLogin = useCallback(async () => {
    const success = await login(userInfo)
    if (success) {
      navigate(PATH_INFO.COMPANY_LIST.PATH)
    } else {
      setStatus('error')
    }
  }, [login, userInfo, navigate]);

  return (
    <div
      className="flex items-center justify-center h-screen "
      style={{ backgroundImage: `url(${bgImg})` }}
    >
      <div className="flex h-[914px] w-[1142px] rounded-[10px] overflow-hidden">
        <div className="flex flex-col justify-between items-center p-[50px] bg-[#F3F3F3] w-full">
          <p className="font-hiragino text-[24px] m-0">WELLCOME AI MEASURE!</p>
          <img src={AiMeasureLogo} alt="logo" className="w-[217px]" />
          <img src={toyoshimaLogo} alt="logo" className="w-[151px]" />
        </div>
        <div className="relative flex flex-col items-center bg-white w-full font-[Poppins] pt-[226px]">
          <p className="font-bold text-[20px] pb-[90px] m-0">Log in</p>
          <form className="flex flex-col">
            <div className="flex flex-col mb-[20px]">
              <label className="text-[16px]">Email(*)</label>
              <Input
                type="email"
                className="w-full font-normal text-[16px]"
                variant="underlined"
                status={status}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setUserInfo((prev) => ({ ...prev, email: e.target.value }))}
              />
            </div>
            <div className="flex flex-col">
              <label className="text-[16px]">Password</label>
              <Input.Password
                variant='underlined'
                status={status}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setUserInfo((prev) => ({ ...prev, password: e.target.value }))}
                className="font-semibold text-[16px]"
              />
            </div>
            <Button
              onClick={onClickLogin}
              color="default"
              variant="solid"
              className="mt-[190px] w-[400px] h-[73px] font-bold text-[16px]"
            >
              login now
            </Button>
          </form>
          <div className="absolute flex justify-center bottom-[50px] w-[175px] h-[31px]" style={{ borderBottom: '1px solid #000' }}>
            <Button color="default" variant="link" className="font-semibold">Fogot your password?</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
